import React, { useEffect } from "react";
import "../../scss/modal.scss";
import { ReactComponent as CloseIcon } from "../../images/cross-icon.svg";
import { ReactComponent as CloseIconFilled } from "../../images/cross-icon-filled.svg";

const BottomPopup = ({
  children,
  isOpen,
  onClose,
  title,
  buttons,
  closeIcon,
  className,
  closeClassName = "",
  bodyClassName = "",
  footerClassName = "",
  hideClose = false,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={`modal-overlay bottom-modal ${className}`}>
      <div className="modal-content">
        {!hideClose && (
          <span className={`modal-close ${closeClassName}`} onClick={onClose}>
            {closeIcon === "filled" ? <CloseIconFilled /> : <CloseIcon />}
          </span>
        )}

        {title && <div className="modal-header">{title}</div>}

        <div className={`modal-body ${bodyClassName}`}>{children}</div>

        {buttons && (
          <div className={`modal-footer ${footerClassName}`}>
            {buttons.map((button, index) => (
              <button
                key={index}
                className={`btn btn-primary ${button.className} ${
                  button.disabled ? "disabled" : ""
                }`}
                onClick={button.onClick}
              >
                {button.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BottomPopup;
